import { Box, Button } from '@zillow/constellation-10';
import { PropertyCardSkeleton } from '../PropertyCardSkeleton';

type Pager = {
  startKey?: string;
  endKey?: string;
  hasMore?: boolean;
};

type Props = {
  pager?: Pager;
  text?: string;
  disabled?: boolean;
  onLoadMoreClick: () => void;
  isLoading?: boolean;
};

const SKELETON_KEYS = ['skeleton-0', 'skeleton-1', 'skeleton-2'];

const InfiniteScroller = ({
  pager = { startKey: '', endKey: '', hasMore: false },
  text = 'Load more',
  disabled = false,
  onLoadMoreClick,
  isLoading = false,
}: Props) => {
  const { hasMore } = pager;

  return (
    <div>
      {hasMore && (
        <>
          {isLoading ? (
            <Box
              css={{
                display: 'grid',
                gap: '12px 24px',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gridAutoRows: '1fr',
                marginTop: '200',
              }}
            >
              {SKELETON_KEYS.map((key) => (
                <PropertyCardSkeleton key={key} />
              ))}
            </Box>
          ) : (
            <Box css={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                tone="brand"
                emphasis="filled"
                onClick={disabled ? undefined : onLoadMoreClick}
                disabled={disabled}
                css={{ marginBlock: '200' }}
              >
                {text}
              </Button>
            </Box>
          )}
        </>
      )}
    </div>
  );
};

export default InfiniteScroller;
